import { ReactNode } from 'react';
import { faSortDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Styled from 'components/goalbar/goalbar-indicator/styled';
import styled from 'styled-components';

interface GoalbarIndicatorProps {
    className?: string;
    children?: ReactNode;
}

const GoalbarIndicatorPrimitive = (props: GoalbarIndicatorProps) => {
    const { children, className = '' } = props;
    return (
        <Styled.Wrapper className={className}>
            {children}
            <FontAwesomeIcon className="text-gray-400" icon={faSortDown} />
        </Styled.Wrapper>
    );
};

const GoalbarIndicator = styled(GoalbarIndicatorPrimitive)``;

export { GoalbarIndicator };
export type { GoalbarIndicatorProps };
